import './cart.css'
import React, { useState, useContext, useEffect, useRef } from 'react'
import ResponsiveAppBar from '../../components/NavbarCustomer'
import { getList } from '../../services/product'
import {
  getList as presetList,
  remove as removePreset,
  batchCreate as batchAddPreset,
  getWishlist,
  removeWishlistItem,
} from '../../services/preset'
import { getMyInformation } from '../../services/customer'
import {
  create as createOrder,
  getList as getOrders,
  getReorderPreview,
} from '../../services/order'
import { UserContext } from '../../context/UserProvider.jsx'
import { DataGrid } from '@mui/x-data-grid'
import { FormGroup, TextField, withStyles } from '@material-ui/core'
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import { useNavigate, useLocation } from 'react-router-dom'
import Select from 'react-select'
import { useParams } from 'react-router-dom'
import StarsIcon from '@mui/icons-material/Stars'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import ReplayIcon from '@mui/icons-material/Replay'
import CloseIcon from '@mui/icons-material/Close'
import HistoryIcon from '@mui/icons-material/History'
import { isMobile } from 'react-device-detect'
import NumberQty from '../../components/NumberQty'
import OrderForm from '../../components/OrderForm/index.jsx'
import { buildReorderCart } from './reorder'

const StyledTextField = withStyles({
  root: {
    '& fieldset': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    backgroundColor: '#fff',
    width: '74%',
  },
})(TextField)

const StyledButton = withStyles({
  root: {
    backgroundColor: '#3675af',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    color: 'white',
  },
})(Button)

const searchOptions = [
  { value: 'item-number', label: 'Item Number' },
  { value: 'name', label: 'Product Name' },
  { value: 'category', label: 'Category' },
]

const wishlistControlHeight = 55

const App = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const [requestedOrderId] = useState(location.state?.reorderOrderId || null)
  const openedRequestedOrder = useRef(false)
  const { token, customerCart: cartItem, setCustomerCart: setCartItem } = useContext(UserContext)
  const [rows, setRows] = useState([])
  const [pageInfoCurrentPage, setPageInfoCurrentPage] = useState(0)
  const [pageInfoTotalRows, setPageInfoTotalRows] = useState(0)
  const [pageInfoRowPerPage, setPageInfoRowPerPage] = useState(100)
  const [loading, setLoading] = useState(true)
  const [filterField, setFilterField] = useState('')
  const searchRef = useRef(null)
  const wishlistRef = useRef(null)
  const orderFormData = useRef(null)
  const [wishlistSubmitting, setWishlistSubmitting] = useState(false)
  const [showMyWishlist, setShowMyWishlist] = useState(false)
  const [wishlistRows, setWishlistRows] = useState([])
  const [wishlistLoading, setWishlistLoading] = useState(false)
  const [selected, setSelected] = useState(null)
  const [cartItemQty, setCartItemQty] = useState(0)
  const [showMyCart, setShowMyCart] = useState(false)
  const [createProgress, setCreateProgress] = useState(false)
  const [reorderDialogOpen, setReorderDialogOpen] = useState(false)
  const [reorderLoading, setReorderLoading] = useState(false)
  const [reorderTargetId, setReorderTargetId] = useState(null)
  const [reorderError, setReorderError] = useState('')
  const [lastOrder, setLastOrder] = useState(null)
  const [showOnly, setShowOnly] = useState({
    value: 'my-list',
    label: 'Show My List',
  })
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'image',
      headerName: 'Image',
      width: 120,
      renderCell: (params) => {
        let url = params.row['image']
        return (
          <div style={{ width: '100%', textAlign: 'center', height: '100px' }}>
            <img src={url} style={{ width: '100px', height: '100px' }} />
          </div>
        )
      },
    },
    { field: 'item-number', headerName: 'Item Number', width: 120 },
    { field: 'name', headerName: 'Product Name', flex: 1 },
    { field: 'category', headerName: 'Category', flex: 1 },
    {
      field: 'bin',
      headerName: 'Available',
      width: 120,
      renderCell: (params) => {
        let bin = params.row['bin']
        return bin && bin != '' && bin === 'AVAILABLE' ? <>YES</> : <>NO</>
      },
    },
    {
      field: 'qty',
      headerName: 'Qty',
      width: 320,
      renderCell: (params) => {
        let qtyItemValue = 1
        if (cartItem[params.row['id']] 
          && cartItem[params.row['id']].qty
          && cartItem[params.row['id']].qty != ''
        ) {
          qtyItemValue = cartItem[params.row['id']].qty;
          console.log('qtyItemValue', qtyItemValue);
        }

        let unitItemValue = { value: 'case', label: 'Case' }
        if (cartItem[params.row['id']]) {
          unitItemValue = cartItem[params.row['id']].type
        }

        return (
          <div style={{ display: 'block' }}>
            <FormGroup row style={{ marginTop: '20px'}}>
              <div >
                <NumberQty
                  defaultValue={qtyItemValue}
                  onChange={(value) => {
                    params.row['qty'] = value
                    handleUpdateQty(params.row['id'], value)
                  }}
                />
              </div>
              <div style={{width: '182px', marginTop: '10px', marginBottom: '20px'}}>
              <Select
                options={[
                  { value: 'unit', label: 'Unit' },
                  { value: 'case', label: 'Case' },
                ]}
                onChange={(value) => {
                  params.row['type'] = value
                  handleUpdateQtyType(params.row['id'], value)
                }}
                placeholder="Type"
                styles={{
                  control: (provided, state) => ({
                    ...provided,
                    background: '#fff',
                    borderColor: '#9e9e9e',
                    boxShadow: state.isFocused ? null : null,
                  }),

                  valueContainer: (provided, state) => ({
                    ...provided,
                    padding: '0 6px',
                  }),

                  input: (provided, state) => ({
                    ...provided,
                    margin: '0px',
                  }),
                  indicatorSeparator: (state) => ({
                    display: 'none',
                  }),
                  indicatorsContainer: (provided, state) => ({
                    ...provided,
                  }),
                  menu: (provided) => ({ ...provided, zIndex: 9999 }),
                }}
                defaultValue={unitItemValue}
                menuPortalTarget={document.body}
                menuPosition={'fixed'}
                // isDisabled={cartItem[params.row['id']] ? true : false}
              />
              </div>
            </FormGroup>
          </div>
        )
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => {
        let bin = params.row['bin']
        // if (!bin || bin == '' || bin == 'N/A') {
        //   return <></>
        // }

        return (
          <div style={{ display: 'block' }}>
            {cartItem[params.row['id']] ? (
              <>
                <Button
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    handleRemove(params.row['id'])
                  }}
                  style={{
                    marginTop: '10px',
                    backgroundColor: '#3675af',
                    color: 'white',
                    width: '100%',
                    float: 'left',
                    backgroundColor: 'red',
                  }}
                >
                  Remove
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    handleRecordAddToCart(params.row)
                  }}
                  style={{
                    marginTop: '10px',
                    backgroundColor: '#3675af',
                    color: 'white',
                    width: '100%',
                    float: 'left',
                  }}
                >
                  {params.row['preset'] && <StarsIcon />} Add
                </Button>
              </>
            )}
          </div>
        )
      },
    },
  ]
  const columnsMobile = [
    { field: 'id', headerName: 'ID', width: 70 },
    {
      field: 'image',
      headerName: 'Image',
      width: 120,
      renderCell: (params) => {
        let url = params.row['image']
        return (
          <div style={{ width: '100%', textAlign: 'center', height: '100px' }}>
            <img src={url} style={{ width: '100px', height: '100px' }} />
          </div>
        )
      },
    },
    { field: 'item-number', headerName: 'Item Number', width: 220 },
    { field: 'name', headerName: 'Product Name', width: 320 },
    { field: 'category', headerName: 'Category', width: 320 },
    {
      field: 'bin',
      headerName: 'Available',
      width: 220,
      renderCell: (params) => {
        let bin = params.row['bin']
        return bin && bin === 'AVAILABLE' && bin != 'N/A' ? <>YES</> : <>NO</>
      },
    },
    {
      field: 'qty',
      headerName: 'Qty',
      width: 320,
      renderCell: (params) => {
        let bin = params.row['bin']
        // if (!bin || bin == '' || bin == 'N/A') {
        //   return <></>
        // }

        let qtyItemValue = 1
        if (cartItem[params.row['id']]) {
          qtyItemValue = cartItem[params.row['id']].qty
        }

        let unitItemValue = { value: 'case', label: 'Case' }
        if (cartItem[params.row['id']]) {
          unitItemValue = cartItem[params.row['id']].type
        }

        return (
          <div style={{ display: 'block' }}>
          <FormGroup row style={{ marginTop: '20px'}}>
            <div >
              <NumberQty
                defaultValue={qtyItemValue}
                onChange={(value) => {
                  params.row['qty'] = value
                  handleUpdateQty(params.row['id'], value)
                }}
              />
            </div>
            <div style={{width: '182px', marginTop: '10px', marginBottom: '20px'}}>
            <Select
              options={[
                { value: 'unit', label: 'Unit' },
                { value: 'case', label: 'Case' },
              ]}
              onChange={(value) => {
                params.row['type'] = value
                handleUpdateQtyType(params.row['id'], value)
              }}
              placeholder="Type"
              styles={{
                control: (provided, state) => ({
                  ...provided,
                  background: '#fff',
                  borderColor: '#9e9e9e',
                  boxShadow: state.isFocused ? null : null,
                }),

                valueContainer: (provided, state) => ({
                  ...provided,
                  padding: '0 6px',
                }),

                input: (provided, state) => ({
                  ...provided,
                  margin: '0px',
                }),
                indicatorSeparator: (state) => ({
                  display: 'none',
                }),
                indicatorsContainer: (provided, state) => ({
                  ...provided,
                }),
                menu: (provided) => ({ ...provided, zIndex: 9999 }),
              }}
              defaultValue={unitItemValue}
              menuPortalTarget={document.body}
              menuPosition={'fixed'}
              // isDisabled={cartItem[params.row['id']] ? true : false}
            />
            </div>
          </FormGroup>
        </div>
        )
      },
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 320,
      renderCell: (params) => {
        let bin = params.row['bin']
        // if (!bin || bin == '' || bin == 'N/A') {
        //   return <></>
        // }

        return (
          <div style={{ display: 'block' }}>
            {cartItem[params.row['id']] ? (
              <>
                <Button
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    handleRemove(params.row['id'])
                  }}
                  style={{
                    marginTop: '10px',
                    backgroundColor: '#3675af',
                    color: 'white',
                    width: '100%',
                    float: 'left',
                    backgroundColor: 'red',
                  }}
                >
                  Remove
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    handleRecordAddToCart(params.row)
                  }}
                  style={{
                    marginTop: '10px',
                    backgroundColor: '#3675af',
                    color: 'white',
                    width: '100%',
                    float: 'left',
                  }}
                >
                  {params.row['preset'] && <StarsIcon />} Add
                </Button>
              </>
            )}
          </div>
        )
      },
    },
  ]

  const [defaultDeliveryAddress, setDeliveryAddress] = useState('')
  const [defaultContactPerson, setContactPerson] = useState('')
  const [defaultContactDetails, setContactDetails] = useState('')

  useEffect(() => {
    let sum = 0
    Object.keys(cartItem).forEach((key) => {
      sum += parseInt(cartItem[key].qty)
    })
    setCartItemQty(sum)

    const handleBeforeUnload = (event) => {
      // check if cart is not empty
      if (Object.keys(cartItem).length > 0) {
        event.preventDefault()
        event.returnValue =
          'Are you sure you want to reload? Cart will be cleared.'
      }
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [cartItem])

  useEffect(() => {
    if (selected != null) {
      loadProducts(
        {
          'current-page': 1,
          'record-per-page': 100,
        },
        selected,
      )
    }
  }, [selected])

  useEffect(() => {
    if (selected != null) {
      loadProducts(
        {
          'current-page': 1,
          'record-per-page': 100,
        },
        selected,
      )
      searchRef.current.value = ''
      setFilterField('')
    }
  }, [showOnly])

  useEffect(() => {
    if (showMyCart) {
      const summary = []
      Object.keys(cartItem).forEach((key) => {
        summary.push(cartItem[key])
      })
      setRows(summary)
    } else if (!showMyWishlist) {
      loadPreset()
    }
  }, [showMyCart])

  useEffect(() => {
    if (showMyWishlist) {
      loadWishlist()
    }
  }, [showMyWishlist])

  useEffect(() => {
    if (token) {
      getMyInformation(token).then((res) => {
        let address = res['address-line-1']

        if (res['address-line-2'] && res['address-line-2'] != '') {
          address += ' ' + res['address-line-2']
        }

        setDeliveryAddress(address.trim())
        setContactDetails(`${res['phone']} - ${res['email']}`)
      })
    }
  }, [])

  const updatePageHandler = (pageInfo) => {
    if (filterField === '') {
      return loadProducts({
        'current-page': pageInfo.page + 1,
        'record-per-page': pageInfo.pageSize,
      });
    }

    if (searchRef.current.value === '') {
      return loadProducts({
        'current-page': pageInfo.page + 1,
        'record-per-page': pageInfo.pageSize,
      });
    }

    loadProducts({
      fields: {
        [filterField]: searchRef.current.value,
      },
      'current-page': pageInfo.page + 1,
      'record-per-page': pageInfo.pageSize,
    })
  }

  const loadPreset = () => {
    setLoading(true)
    presetList(token, {
      'customer-specific': true,
      'record-per-page': 'all',
      'user-specific': false,
      fields: {},
    }).then((res) => {
      const summary = {}
      const productEntityIds = []
      const collection = res.collection ?? []
      collection.forEach((item) => {
        summary[parseInt(item.data['product-id'])] = item.raw.id
        productEntityIds.push(parseInt(item.data['product-id']))
      })
      setSelected(productEntityIds)
    })
  }

  const loadProducts = (payload, presetSelected = []) => {
    if (presetSelected.length === 0) {
      presetSelected = selected
    }

    const isMyListView = showOnly.value === 'my-list'
    const isCustomSearch = !!payload.fields && Object.keys(payload.fields).length > 0
    const payloadFields = payload.fields ?? {}
    const shouldApplyAvailabilityFilter = !isMyListView && !isCustomSearch
    const requestFields = shouldApplyAvailabilityFilter
      ? { ...payloadFields, bin: 'AVAILABLE' }
      : payloadFields

    getList(token, {
      'user-specific': false,
      entities: showOnly.value === 'my-list' ? presetSelected : [],
      'sort-entities-first': presetSelected,
      'per-page': pageInfoRowPerPage,
      ...payload,
      fields: requestFields,
      ...(shouldApplyAvailabilityFilter ? { operator: '=' } : {}),
      'available-only': shouldApplyAvailabilityFilter,
    }).then((res) => {
      const summary = []
      res.collection.forEach((item) => {
        summary.push({
          id: item.raw.id,
          preset: presetSelected.includes(item.raw.id),
          qty: 1,
          type: { value: 'case', label: 'Case' },
          ...item.data,
        })
      })
      summary.sort((a, b) => b.preset - a.preset)
      setRows(summary)
      setPageInfoCurrentPage(res['current-page'])
      setPageInfoRowPerPage(res['record-per-page'])
      setPageInfoTotalRows(res['data-total'])
      setLoading(false)
    })
  }

  const searchHandler = () => {
    if (filterField === '') {
      return alert('Please select a field to search')
    }

    if (searchRef.current.value === '') {
      return loadProducts({})
    }

    loadProducts({
      fields: {
        [filterField]: searchRef.current.value,
      },
    })
  }

  const handleRecordAddToCart = (data) => {
    const item = { ...cartItem }
    item[data.id] = data

    if (
      item[data.id]['qty'] === '' ||
      item[data.id]['qty'] === null ||
      item[data.id]['qty'] === undefined ||
      item[data.id]['qty'] == 0
    ) {
      alert('Please enter quantity')
    } else {
      setCartItem(item)
    }
  }

  const handleUpdateQty = (id, qty) => {
    const item = { ...cartItem }
    if (item[id]) {
      item[id]['qty'] = qty;
      setCartItem(item)
    }
  }

  const handleUpdateQtyType = (id, type) => {
    const item = { ...cartItem }
    if (item[id]) {
      item[id]['type'] = type
      setCartItem(item)
    }
  }

  const handleRemove = (id) => {
    const item = { ...cartItem }
    delete item[id]
    setCartItem(item)
  }

  const handleOpenReorder = async (orderId = null) => {
    setReorderTargetId(orderId)
    setReorderDialogOpen(true)
    setReorderLoading(true)
    setReorderError('')
    setLastOrder(null)

    try {
      let selectedId = orderId
      if (!selectedId) {
        const orderResponse = await getOrders(token, {
          'user-specific': true, 'current-page': 1, 'record-per-page': 1,
        })
        if (!Array.isArray(orderResponse?.collection)) throw new Error('Unable to load order history')
        selectedId = orderResponse.collection[0]?.raw.id
        if (!selectedId) return
      }
      const preview = await getReorderPreview(token, selectedId)
      if (!preview.order || !Array.isArray(preview.items) || !Array.isArray(preview.products)) throw new Error('Unable to load order')
      const selectedOrder = preview.order
      const orderItems = preview.items
      const products = preview.products

      const { cart, unavailableItemCount } = buildReorderCart(
        orderItems,
        products,
      )

      setLastOrder({
        id: selectedOrder.raw.id,
        orderNumber: selectedOrder.data?.['order-number'],
        cart,
        itemCount: Object.keys(cart).length,
        unavailableItemCount,
      })
    } catch (error) {
      setReorderError(
        'We could not load the selected order. Please close this window and try again.',
      )
    } finally {
      setReorderLoading(false)
    }
  }

  useEffect(() => {
    if (!token || !requestedOrderId || openedRequestedOrder.current) return
    openedRequestedOrder.current = true
    void handleOpenReorder(requestedOrderId)
    navigate(location.pathname, { replace: true, state: null })
    // Consume the selected order once; reopening is an explicit customer action.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, requestedOrderId])

  const handleReorder = () => {
    if (!lastOrder || lastOrder.itemCount === 0) {
      return
    }

    setCartItem(lastOrder.cart)
    setShowMyWishlist(false)
    setShowMyCart(true)
    setReorderDialogOpen(false)
  }

  const loadWishlist = () => {
    setWishlistLoading(true)
    getWishlist(token).then((res) => {
      const summary = (res.collection ?? []).map((item, index) => ({
        id: index + 1,
        'item-number': item['item-number'],
        'submitted-at': item['submitted-at']
          ? new Date(item['submitted-at']).toLocaleString()
          : '',
        'submitted-at-raw': item['submitted-at'] ?? '',
      }))
      setWishlistRows(summary)
      setWishlistLoading(false)
    })
  }

  const handleWishlistDelete = (row) => {
    const confirm = window.confirm(
      `Remove item ${row['item-number']} from your wishlist?`,
    )
    if (!confirm) {
      return
    }

    setWishlistLoading(true)
    removeWishlistItem(token, {
      'item-number': row['item-number'],
      'submitted-at': row['submitted-at-raw'],
    }).then(() => {
      loadWishlist()
    })
  }

  const wishlistColumns = [
    { field: 'item-number', headerName: 'Item Number', flex: 1 },
    { field: 'submitted-at', headerName: 'Submitted', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => (
        <Button
          variant="contained"
          disableElevation
          onClick={() => handleWishlistDelete(params.row)}
          style={{
            backgroundColor: 'red',
            color: 'white',
          }}
        >
          Delete
        </Button>
      ),
    },
  ]

  const handleWishlistSubmit = () => {
    const itemNumber = wishlistRef.current?.value?.trim()

    if (!itemNumber) {
      return alert('Please enter an item number')
    }

    setWishlistSubmitting(true)
    batchAddPreset(token, {
      'product-ids': [itemNumber],
      wishlist: true,
    })
      .then(() => {
        wishlistRef.current.value = ''
        alert(
          'Your item has been added to your wishlist. We will get the information for you by the next day.',
        )
        if (showMyWishlist) {
          loadWishlist()
        } else {
          loadPreset()
        }
      })
      .finally(() => {
        setWishlistSubmitting(false)
      })
  }

  const handleSubmit = () => {
    const required = ['contactPerson', 'contactDetails', 'deliveryAddress', 'paymentType', 'deliveryTime', 'deliveryDate'];
    console.log('orderFormData', orderFormData);
    const orderFormDataList = orderFormData.current.submitData();
    let missingField = false;

    required.forEach((field) => {
      if (!orderFormDataList[field] || orderFormDataList[field] === '') {
        missingField = true;
      }
    });
    
    if (missingField) {
      return alert('Please fill in all required fields');
    }

    const confirm = window.confirm('Are you sure you want to submit this order?')
    if (!confirm) {
      return
    }

    setCreateProgress(true)
    createOrder(token, {
      'delivery-address': orderFormDataList.deliveryAddress,
      'contact-person': orderFormDataList.contactPerson,
      'contact-details': orderFormDataList.contactDetails,
      'delivery-note': orderFormDataList.deliveryNote,
      'payment-type': orderFormDataList.paymentType,
      'delivery-time': orderFormDataList.deliveryTime,
      'delivery-date': orderFormDataList.deliveryDate,
      items: cartItem,
    }).then((res) => {
      alert('Order has been submitted')
      setCreateProgress(false)
      navigate('/orders')
    })
  }

  const wishlistAddFormControls = (
    <FormGroup row style={{ margin: 0, alignItems: 'stretch' }}>
      <StyledTextField
        variant="outlined"
        placeholder="Item number"
        inputRef={wishlistRef}
        style={{
          width: isMobile ? '100%' : '220px',
          margin: 0,
        }}
        InputProps={{
          style: {
            height: wishlistControlHeight,
            boxSizing: 'border-box',
          },
        }}
      />
      <StyledButton
        variant="contained"
        disableElevation
        onClick={handleWishlistSubmit}
        disabled={wishlistSubmitting}
        style={{
          height: wishlistControlHeight,
          minHeight: wishlistControlHeight,
          padding: '0 16px',
          whiteSpace: 'nowrap',
        }}
      >
        {wishlistSubmitting ? 'Adding...' : 'Add to wishlist'}
      </StyledButton>
    </FormGroup>
  )

  return (
    <>
      <Dialog
        open={reorderDialogOpen}
        onClose={() => setReorderDialogOpen(false)}
        aria-labelledby="reorder-dialog-title"
        aria-describedby="reorder-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          id="reorder-dialog-title"
          sx={{ display: 'flex', alignItems: 'center', pr: 7 }}
        >
          {reorderTargetId ? 'Reorder selected order' : 'Reorder your last order'}
          <IconButton
            aria-label="Close reorder dialog"
            onClick={() => setReorderDialogOpen(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              width: 44,
              height: 44,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Box id="reorder-dialog-description">
            {reorderLoading ? (
              <Box
                sx={{
                  minHeight: 144,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 2,
                }}
              >
                <CircularProgress size={32} />
                <Typography>Checking your order history...</Typography>
              </Box>
            ) : reorderError ? (
              <Alert severity="error">{reorderError}</Alert>
            ) : !lastOrder ? (
              <Box
                sx={{
                  minHeight: 144,
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <HistoryIcon sx={{ fontSize: 44, color: 'text.secondary' }} />
                <Typography variant="h6">No past orders</Typography>
                <Typography color="text.secondary">
                  You do not have an order to reorder yet.
                </Typography>
              </Box>
            ) : lastOrder.itemCount === 0 ? (
              <Box
                sx={{
                  minHeight: 144,
                  textAlign: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 1,
                }}
              >
                <HistoryIcon sx={{ fontSize: 44, color: 'text.secondary' }} />
                <Typography variant="h6">No items to reorder</Typography>
                <Typography color="text.secondary">
                  We could not find any available items from this order.
                </Typography>
              </Box>
            ) : (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Alert severity="info">
                  This will reorder the same items and quantities from order{lastOrder.orderNumber
                    ? ` (${lastOrder.orderNumber})`
                    : ''}.
                </Alert>
                <Typography>
                  {Object.keys(cartItem).length > 0
                    ? 'Your current cart will be replaced with the items from this order.'
                    : 'The items from this order will be added to your cart.'}
                </Typography>
                <Typography color="text.secondary">
                  {lastOrder.itemCount}{' '}
                  {lastOrder.itemCount === 1 ? 'item' : 'items'} will be added.
                </Typography>
                {lastOrder.unavailableItemCount > 0 && (
                  <Alert severity="warning">
                    {lastOrder.unavailableItemCount}{' '}
                    {lastOrder.unavailableItemCount === 1 ? 'item is' : 'items are'} no
                    longer available and will not be added.
                  </Alert>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions sx={{ px: 3, py: 2 }}>
          <Button
            onClick={() => setReorderDialogOpen(false)}
            sx={{ minHeight: 44 }}
          >
            {lastOrder || reorderError ? 'Cancel' : 'Close'}
          </Button>
          {lastOrder && lastOrder.itemCount > 0 && !reorderError && (
            <Button
              variant="contained"
              disableElevation
              onClick={handleReorder}
              startIcon={<ReplayIcon />}
              sx={{ minHeight: 44, backgroundColor: '#3675af' }}
            >
              Reorder items
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ResponsiveAppBar />
      <div className={showMyCart ? 'customer-cart-background' : undefined}><Container maxWidth={'xl'} className={showMyCart ? 'customer-cart-page' : undefined}>
        <Grid container spacing={2} sx={showMyCart ? { display: 'none' } : undefined}>
          <Grid item xs={12} md={4}>
            {showMyWishlist && <h1>My Wishlist</h1>}
            {!showMyCart && !showMyWishlist && <h1>Products</h1>}
          </Grid>
          <Grid item xs={8}></Grid>
        </Grid>

        <Grid container spacing={2}>
          {showMyCart ? (
            <>
              <Grid item xs={12}>
                <div className="customer-cart-header">
                  <div><h1>My Cart</h1><p>Review your items and delivery details before placing your order.</p></div>
                  <div className="customer-cart-actions">
                    <Button variant="outlined" onClick={() => setShowMyCart(false)}>Continue shopping</Button>
                    <Button variant="contained" disableElevation disabled={createProgress || Object.keys(cartItem).length === 0} onClick={handleSubmit} aria-label={`${cartItemQty} Submit`}>
                      {createProgress ? 'Submitting…' : <>Submit order <span className="cart-count">{cartItemQty}</span></>}
                    </Button>
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={12}>
                <OrderForm 
                  ref={orderFormData}
                  defaultData = {{
                    deliveryAddress: defaultDeliveryAddress,
                    contactPerson: defaultContactPerson,
                    contactDetails: defaultContactDetails,
                  }}
                />
              </Grid>
            </>
          ) : !showMyWishlist && !showMyCart ? (
            <>
              <Grid item xs={12} md={2}>
                <div style={{ marginTop: '20px' }}>
                  <Select
                    options={searchOptions}
                    onChange={(e) => setFilterField(e.value)}
                    placeholder="Filter by"
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        background: '#fff',
                        borderColor: '#9e9e9e',
                        height: '55px',
                        boxShadow: state.isFocused ? null : null,
                      }),

                      valueContainer: (provided, state) => ({
                        ...provided,
                        height: '55px',
                        padding: '0 6px',
                      }),

                      input: (provided, state) => ({
                        ...provided,
                        margin: '0px',
                      }),
                      indicatorSeparator: (state) => ({
                        display: 'none',
                      }),
                      indicatorsContainer: (provided, state) => ({
                        ...provided,
                        height: '55px',
                      }),
                    }}
                    value={
                      searchOptions.find((obj) => obj.value === filterField) ??
                      null
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3}>
                <FormGroup
                  row
                  style={{
                    display: 'grid',
                    gridTemplateColumns: 'minmax(0, 1fr) 92px',
                    marginTop: '20px',
                    width: '100%',
                  }}
                >
                  <StyledTextField
                    variant="outlined"
                    placeholder="Search"
                    inputRef={searchRef}
                    style={{ width: '100%', minWidth: 0 }}
                    InputProps={{ style: { height: '55px' } }}
                  />
                  <StyledButton
                    variant="contained"
                    disableElevation
                    onClick={() => searchHandler()}
                    style={{ height: '55px', minWidth: '92px' }}
                  >
                    Search
                  </StyledButton>
                </FormGroup>
              </Grid>
              <Grid item xs={12} md={3}>
                <div style={{ marginTop: '20px' }}>
                  <Select
                    options={[
                      { value: 'my-list', label: 'Show My List' },
                      { value: 'all', label: 'Show All Product' },
                    ]}
                    onChange={(e) => setShowOnly(e)}
                    placeholder="Show Products"
                    defaultValue={showOnly}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        background: '#fff',
                        borderColor: '#9e9e9e',
                        height: '55px',
                        boxShadow: state.isFocused ? null : null,
                      }),

                      valueContainer: (provided, state) => ({
                        ...provided,
                        height: '55px',
                        padding: '0 6px',
                      }),

                      input: (provided, state) => ({
                        ...provided,
                        margin: '0px',
                      }),
                      indicatorSeparator: (state) => ({
                        display: 'none',
                      }),
                      indicatorsContainer: (provided, state) => ({
                        ...provided,
                        height: '55px',
                      }),
                    }}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="outlined"
                  disableElevation
                  onClick={() => handleOpenReorder()}
                  startIcon={<ReplayIcon />}
                  style={{
                    marginTop: '20px',
                    borderColor: '#3675af',
                    color: '#3675af',
                    height: '55px',
                    width: '100%',
                    whiteSpace: 'nowrap',
                  }}
                  fullWidth={isMobile}
                >
                  Reorder
                </Button>
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="contained"
                  disableElevation
                  onClick={() => {
                    setShowMyCart(!showMyCart)
                  }}
                  style={{
                    marginTop: '20px',
                    backgroundColor:
                      Object.keys(cartItem).length === 0
                        ? '#a3a3a3'
                        : '#3675af',
                    color: 'white',
                    height: '55px',
                    width: '100%',
                  }}
                  disabled={Object.keys(cartItem).length === 0}
                  fullWidth={isMobile}
                >
                  {cartItemQty} <ShoppingCartIcon /> My Cart
                </Button>
              </Grid>
            </>
          ) : null}
        </Grid>

        {showMyWishlist && (
          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: '16px',
                  padding: '16px 20px',
                  backgroundColor: '#f0f6fc',
                  border: '1px solid #c5d9ed',
                  borderRadius: '8px',
                }}
              >
                <p style={{ margin: 0, flex: '1 1 200px', color: '#1a3a5c' }}>
                  Add another item to your wishlist — we will get the
                  information for you by the next day.
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    alignItems: 'stretch',
                    gap: '8px',
                    marginLeft: isMobile ? 0 : 'auto',
                  }}
                >
                  {wishlistAddFormControls}
                  <Button
                    variant="contained"
                    disableElevation
                    onClick={() => setShowMyWishlist(false)}
                    style={{
                      height: wishlistControlHeight,
                      minHeight: wishlistControlHeight,
                      backgroundColor: '#3675af',
                      color: 'white',
                      padding: '0 24px',
                      whiteSpace: 'nowrap',
                    }}
                    fullWidth={isMobile}
                  >
                    Back
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        )}

        {!showMyCart && !showMyWishlist && (
          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: '16px',
                  padding: '16px 20px',
                  backgroundColor: '#f0f6fc',
                  border: '1px solid #c5d9ed',
                  borderRadius: '8px',
                }}
              >
                <p style={{ margin: 0, flex: '1 1 280px', color: '#1a3a5c' }}>
                  Can&apos;t find your item on the list? Add it to your wishlist
                  — we will get the information for you by the next day.
                </p>
                <div
                  style={{
                    display: 'flex',
                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                    alignItems: 'stretch',
                    flex: '0 1 auto',
                    gap: '8px',
                  }}
                >
                  {wishlistAddFormControls}
                  <Button
                    variant="outlined"
                    disableElevation
                    onClick={() => setShowMyWishlist(true)}
                    style={{
                      borderColor: '#3675af',
                      color: '#3675af',
                      height: wishlistControlHeight,
                      minHeight: wishlistControlHeight,
                      padding: '0 16px',
                      borderRadius: '4px',
                      whiteSpace: 'nowrap',
                    }}
                    fullWidth={isMobile}
                  >
                    View my wishlist
                  </Button>
                </div>
              </div>
            </Grid>
          </Grid>
        )}

        <div
          style={{
            height: showMyCart ? 'auto' : '80vh',
            width: '100%',
            backgroundColor: '#ffff',
            marginTop: '20px',
          }}
        >
          {showMyWishlist ? (
            <DataGrid
              rows={wishlistRows}
              columns={wishlistColumns}
              loading={wishlistLoading}
              disableColumnFilter
              disableColumnMenu
              autoHeight
              hideFooter={wishlistRows.length <= 10}
            />
          ) : showMyCart ? (
            <DataGrid
              autoHeight
              className="customer-cart-table"
              disableRowSelectionOnClick
              rows={rows}
              columns={isMobile ? columnsMobile : columns}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    id: false,
                  },
                },
              }}
              loading={loading}
              disableColumnFilter
              disableColumnMenu
              rowHeight={125}
            />
          ) : (
            <DataGrid
              rows={rows}
              columns={isMobile ? columnsMobile : columns}
              initialState={{
                columns: {
                  columnVisibilityModel: {
                    id: false,
                  },
                },
                pagination: {
                  paginationModel: {
                    pageSize: pageInfoRowPerPage,
                    page: pageInfoCurrentPage,
                  },
                },
              }}
              pagination
              paginationMode="server"
              rowCount={pageInfoTotalRows}
              loading={loading}
              onPaginationModelChange={(newPage) => updatePageHandler(newPage)}
              disableColumnFilter
              disableColumnMenu
              rowHeight={125}
            />
          )}
        </div>
      </Container></div>
    </>
  )
}

export default App
